import { render, staticRenderFns } from "./ExchangeProduct.vue?vue&type=template&id=41408c9f&scoped=true&"
import script from "./ExchangeProduct.vue?vue&type=script&lang=js&"
export * from "./ExchangeProduct.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeProduct.vue?vue&type=style&index=0&id=41408c9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41408c9f",
  null
  
)

component.options.__file = "ExchangeProduct.vue"
export default component.exports